export const POSTHOG_TOOLBAR_STORAGE_KEY = 'posthogToolbarData'
